// jQuery free
import {
    getVehicleSelectionVehicleBrands,
    getVehicleSelectionVehicleModels,
    getVehicleSelectionVehicleMotorizations
} from './api';
import {getSelectedVehicle, getSelectedVehicleType} from './payload';
import {onDOMReady} from './dom';

const CLASS_VEHICLE_SELECTION_FORM = 'vehicleSelection__form';
const CLASS_VEHICLE_SELECTION_VEHICLE_TYPE = 'vehicleSelection__vehicleType';
const CLASS_VEHICLE_SELECTION_VEHICLE_BRAND = 'vehicleSelection__vehicleBrand';
const CLASS_VEHICLE_SELECTION_VEHICLE_MODEL = 'vehicleSelection__vehicleModel';
const CLASS_VEHICLE_SELECTION_VEHICLE_MOTORIZATION = 'vehicleSelection__vehicleMotorization';
const CLASS_VEHICLE_SELECTION_SPINNER = 'vehicleSelection__spinner';
const CLASS_VEHICLE_SELECTION_MOBILE = 'vehicleSelection__mobile';
const CLASS_SELECTED = '--selected';
const DATA_DEFAULT_VEHICLE_TYPE = 'data-default-vehicle-type';
const VEHICLE_ID_PLACEHOLDER = '__vehicleId__';
const VEHICLE_MOTORIZATION_STEP = 'vehicleMotorization';

export class KvikVehicleSelection extends HTMLElement {
    constructor() {
        super();

        this.state = {
            formElements: null,
            submitButtonElements: null,
            selectVehicleHandle: null,
            vehicleConfig: {},
            vehicleType: {
                buttonElements: null,
                value: null
            },
            selectSteps: {
                vehicleBrand: this.createSelectStepState(),
                vehicleModel: this.createSelectStepState(),
                vehicleMotorization: this.createSelectStepState()
            }
        };
    }

    connectedCallback() {
        onDOMReady(() => {
            try {
                this.state.vehicleConfig = JSON.parse(this.dataset.vehicleConfig || '{}');
            } catch (e) {
                this.state.vehicleConfig = {};
            }

            if (!this.state.vehicleConfig || typeof this.state.vehicleConfig !== 'object') {
                this.state.vehicleConfig = {};
            }

            this.state.selectVehicleHandle = this.dataset.selectVehicleHandle || null;

            this.state.formElements = this.querySelectorAll(`.${CLASS_VEHICLE_SELECTION_FORM}`);
            if (this.state.formElements.length === 0) {
                return;
            }

            this.initVehicleSelectionForm();
            this.initVehicleSelectionMobile();
        });
    }

    createSelectStepState() {
        return {
            selectElements: null,
            spinnerElements: [],
            hintElements: [],
            options: [],
            id: null,
            url: null,
            isLoading: false,
            defaultName: null,
            isFocused: false
        };
    }

    getDataOriginsForCurrentType() {
        const vehicleType = this.state.vehicleType.value;
        if (!vehicleType || !this.state.vehicleConfig[vehicleType]) {
            return [];
        }

        const origins = this.state.vehicleConfig[vehicleType];
        if (!Array.isArray(origins)) {
            return [];
        }

        return origins;
    }

    initVehicleSelectionForm() {
        const state = this.state;

        state.vehicleType.buttonElements = this.getElementsByClassName(CLASS_VEHICLE_SELECTION_VEHICLE_TYPE);
        state.selectSteps.vehicleBrand.selectElements = this.getElementsByClassName(CLASS_VEHICLE_SELECTION_VEHICLE_BRAND);
        state.selectSteps.vehicleModel.selectElements = this.getElementsByClassName(CLASS_VEHICLE_SELECTION_VEHICLE_MODEL);
        state.selectSteps.vehicleMotorization.selectElements = this.getElementsByClassName(CLASS_VEHICLE_SELECTION_VEHICLE_MOTORIZATION);
        state.submitButtonElements = this.querySelectorAll(`.${CLASS_VEHICLE_SELECTION_FORM} button[type=submit]`);

        const selectedVehicle = getSelectedVehicle();
        const selectedVehicleType = getSelectedVehicleType();
        let isVehicleSelected = false;

        if (selectedVehicle && selectedVehicleType) {
            isVehicleSelected = true;
            state.vehicleType.value = selectedVehicleType;

            state.selectSteps.vehicleBrand.id = selectedVehicle.vehicleBrandId;
            state.selectSteps.vehicleModel.id = selectedVehicle.vehicleModelId;
            state.selectSteps.vehicleMotorization.id = selectedVehicle.id;

            state.selectSteps.vehicleBrand.defaultName = selectedVehicle.vehicleBrandName;
            state.selectSteps.vehicleModel.defaultName = selectedVehicle.vehicleModelName;
            state.selectSteps.vehicleMotorization.defaultName = selectedVehicle.slug;

            state.selectSteps.vehicleMotorization.url = selectedVehicle.url;
        }

        for (const btn of state.vehicleType.buttonElements) {
            if (btn.classList.contains(`--${state.vehicleType.value}`)) {
                btn.classList.add(CLASS_SELECTED);
            }

            btn.onclick = (e) => {
                e.preventDefault();
                this.changeVehicleType(btn.value);
            };
        }

        const stepNames = Object.keys(state.selectSteps);

        for (const stepName of stepNames) {
            const currentStep = state.selectSteps[stepName];

            for (const selectEl of currentStep.selectElements) {
                currentStep.hintElements.push(selectEl.previousElementSibling);
                currentStep.spinnerElements.push(this.createSpinnerElement(selectEl));

                selectEl.addEventListener('focus', () => {
                    currentStep.isFocused = true;
                    this.updateSelectStepHintVisibility(stepName);
                });

                selectEl.addEventListener('blur', () => {
                    currentStep.isFocused = false;
                    this.updateSelectStepHintVisibility(stepName);
                });

                if (isVehicleSelected) {
                    selectEl.innerHTML += this.createSelectedOption(
                        currentStep.id,
                        currentStep.defaultName
                    );
                }

                selectEl.onchange = () => {
                    const linkHandle = state.selectVehicleHandle;
                    const option = this.parseSelectedOption(selectEl);
                    currentStep.isFocused = false;

                    if (linkHandle && stepName === VEHICLE_MOTORIZATION_STEP) {
                        window.location.href = linkHandle.replace(VEHICLE_ID_PLACEHOLDER, option.id);
                    } else if (option.id !== currentStep.id) {
                        this.changeSelect(stepName, option.id, option.url);
                    } else {
                        this.updateSelectStepHintVisibility(stepName);
                    }
                };
            }
        }

        if (this.getVehicleMotorizationUrl()) {
            const stepNames = Object.keys(state.selectSteps);
            this.loadSelectStepsOptions(stepNames);
        } else {
            let vehicleTypeValue;

            if (state.vehicleType.buttonElements.length > 0) {
                vehicleTypeValue = state.vehicleType.buttonElements[0].value;
            } else {
                vehicleTypeValue = this.getAttribute(DATA_DEFAULT_VEHICLE_TYPE);
            }

            this.changeVehicleType(vehicleTypeValue);
        }
    }

    createSpinnerElement(selectElement) {
        const spinner = document.createElement('div');
        spinner.className = CLASS_VEHICLE_SELECTION_SPINNER;
        spinner.innerHTML = km_spinner.html;
        spinner.hidden = true;
        selectElement.parentNode.insertBefore(spinner, selectElement);
        return spinner;
    }

    parseSelectedOption(selectElement, parseOptionElements = false) {
        const id = parseInt(selectElement.value) || null;
        const urlParts = selectElement.value.split(';');
        const url = urlParts.length > 1 ? urlParts[1] : null;
        let name = null;

        if (parseOptionElements) {
            for (const optionEl of selectElement.children) {
                if (optionEl.selected) {
                    name = optionEl.textContent;
                    break;
                }
            }
        }

        return {
            id: id,
            url: url,
            name: name,
            groupName: null
        };
    }

    changeVehicleType(value) {
        this.state.vehicleType.value = value;
        const names = Object.keys(this.state.selectSteps);
        this.clearSelectSteps(names);
        this.loadSelectStepsOptions([names[0]]);
    }

    changeSelect(name, id, url) {
        const currentStep = this.state.selectSteps[name];
        currentStep.id = id;
        currentStep.url = url;

        const nextStepNames = this.getAllNextSelectStepNames(name);
        this.clearSelectSteps(nextStepNames);

        this.render();

        const nextStepName = this.getNextSelectStepName(name);
        if (nextStepName) {
            this.loadSelectStepsOptions([nextStepName]);
        } else {
            this.render();
        }
    }

    loadSelectStepsOptions(names) {
        for (const name of names) {
            this.state.selectSteps[name].isLoading = true;
        }

        this.render();

        const calls = names.map(async (name) => {
            try {
                const dataOrigins = this.getDataOriginsForCurrentType();
                
                let data;

                switch (name) {
                    case 'vehicleBrand':
                        data = await getVehicleSelectionVehicleBrands(
                            this.state.vehicleType.value,
                            dataOrigins.length > 0 ? dataOrigins : null
                        );
                        break;
                    case 'vehicleModel':
                        data = await getVehicleSelectionVehicleModels(
                            this.state.vehicleType.value,
                            this.state.selectSteps.vehicleBrand.id,
                            dataOrigins.length > 0 ? dataOrigins : null
                        );
                        break;
                    case 'vehicleMotorization':
                        data = await getVehicleSelectionVehicleMotorizations(
                            this.state.vehicleType.value,
                            this.state.selectSteps.vehicleBrand.id,
                            this.state.selectSteps.vehicleModel.id,
                            dataOrigins.length > 0 ? dataOrigins : null
                        );
                        break;
                }

                this.state.selectSteps[name].options = data || [];
            } catch (error) {
                console.error(`Error loading ${name}:`, error);
                this.state.selectSteps[name].options = [];
            }
            this.state.selectSteps[name].isLoading = false;
        });

        Promise.all(calls).then(() => this.render());
    }

    clearSelectSteps(names) {
        for (const n of names) {
            const step = this.state.selectSteps[n];
            step.options = [];
            step.id = null;
            step.url = null;
        }
    }

    updateSelectStepHintVisibility(stepName) {
        const step = this.state.selectSteps[stepName];
        const isHidden = step.options.length === 0 || step.isLoading || !!step.id || step.isFocused;

        for (const hint of step.hintElements) {
            hint.hidden = isHidden;
        }
    }

    getAllNextSelectStepNames(name = '') {
        const names = Object.keys(this.state.selectSteps);
        const index = names.indexOf(name);

        return index === -1 ? [] : names.slice(index + 1);
    }

    getNextSelectStepName(name = '') {
        return this.getAllNextSelectStepNames(name)[0] || null;
    }

    getVehicleMotorizationUrl() {
        return this.state.selectSteps.vehicleMotorization.url;
    }

    render() {
        const state = this.state;

        for (const btn of state.vehicleType.buttonElements) {
            btn.disabled = false;
            btn.classList.toggle(CLASS_SELECTED, btn.value === state.vehicleType.value);
        }

        const stepNames = Object.keys(state.selectSteps);
        for (const stepName of stepNames) {
            const step = state.selectSteps[stepName];
            const isDisabled = step.options.length === 0;
            const isLoading = step.isLoading;
            const renderedOptions = this.renderSelectStepOptions(stepName);

            for (const selectEl of step.selectElements) {
                selectEl.innerHTML = renderedOptions;
                selectEl.disabled = isDisabled || isLoading;
            }

            for (const spinner of step.spinnerElements) {
                spinner.hidden = !isLoading;
            }

            this.updateSelectStepHintVisibility(stepName);
        }

        for (const form of state.formElements) {
            form.action = this.getVehicleMotorizationUrl() || '';
        }

        for (const btn of state.submitButtonElements) {
            btn.disabled = !this.getVehicleMotorizationUrl();
        }
    }

    renderSelectStepOptions(stepName) {
        const step = this.state.selectSteps[stepName];
        let html = '<option></option>';
        let lastGroup = null;

        if (!Array.isArray(step.options)) {
            return html;
        }

        for (const opt of step.options) {
            if (lastGroup !== opt.groupName) {
                if (lastGroup !== null) {
                    html += `</optgroup>`;
                }
                html += `<optgroup label="${opt.groupName}">`;
                lastGroup = opt.groupName;
            }
            const value = opt.id + (opt.url ? `;${opt.url}` : '');
            const selected = opt.id === step.id ? 'selected' : '';
            html += `<option value="${value}" ${selected}>${opt.name}</option>`;
        }
        if (lastGroup !== null) {
            html += `</optgroup>`;
        }
        return html;
    }

    createSelectedOption(id, name) {
        return `<option selected="selected" value="${id}">${name}</option>`;
    }

    initVehicleSelectionMobile() {
        const selectedVehicle = getSelectedVehicle();
        if (!selectedVehicle) return;

        const mobileEls = this.getElementsByClassName(CLASS_VEHICLE_SELECTION_MOBILE);
        for (const mobile of mobileEls) {
            if (selectedVehicle.url) {
                mobile.getElementsByClassName('vehicleSelection__mobile__button')[0].href = selectedVehicle.url;
            }

            if (selectedVehicle.imageUrl) {
                const img = mobile.getElementsByClassName('vehicleSelection__mobile__image')[0];
                img.hidden = false;
                img.src = selectedVehicle.imageUrl;
            }
            mobile.getElementsByClassName('vehicleSelection__mobile__selectPrompt')[0].hidden = true;
            mobile.getElementsByClassName('vehicleSelection__mobile__vehicleName')[0].innerHTML =
                selectedVehicle.nameWithPowerYears;
            mobile.getElementsByClassName('vehicleSelection__mobile__vehicleBrandModel')[0].innerHTML =
                `${selectedVehicle.vehicleBrandName} ${selectedVehicle.vehicleModelNameWithoutCodes}`;
        }
    }
}

if (typeof customElements !== 'undefined') {
    customElements.define('kvik-vehicle-selection', KvikVehicleSelection);
}
